import React, { useContext } from 'react'
import { Layout, Row, Col } from "antd";
import { NavView } from '../../components/NavView';
import logo from '../../assets/artwork.png';
import principleLogo from '../../assets/principles.png';
import { MainSlogan } from '../../components/Landing/MainSlogan';
import { PurposeText } from '../../components/Landing/PurposeText';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import './Landing.css';
import { AppContext } from '../../util/context';


const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

const { Content } = Layout;

export const Landing = ({setShowAuthenticator}) => {
    const {
        SignIn
    } = useContext(AppContext);
    return (
        <Layout className="layout">
            <Content style={{ padding: "0", backgroundColor: "white" }}>
                <NavView landing = {true} setShowAuthenticator={setShowAuthenticator}/>

                <Row
                    style={{
                        
                        marginTop: "9dvh",
                        
                    }}
                >
                    <Col
                        span={24}
                    >
                        <Row
                            className="mainLogoContainer"
                        >
                            <Col
                                xl={{span: 22}}
                                lg={{span: 24}}
                                md={{span: 20}}
                                sm={{span: 20}}
                                xs={{span: 20}}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: "100%"
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <img
                                        src={logo}
                                        alt='logo'
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                            </Col>
                            
                        </Row>
                                    
                        <MainSlogan/>
                    </Col>

                </Row>

                <PurposeText/>

                <Row 
                    className="wordCloudContainer"
                >
                    <Col
                        span={24}
                    >

                        <Row>

                            <Col
                                span={24}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        src={principleLogo}
                                        alt='principleLogo'
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    
                </Row>

                <Row 
                    className="footerContainer"
                >
                    <Col
                        span={24}
                        style={{
                            padding: "0"
                        }}
                    >
                        <StyledDiv>

                            <Row
                                className="footerNoteContainer"
                            >
                                <Col
                                    xl={{span: 16}}
                                    lg={{span: 16}}
                                    md={{span: 16}}
                                    sm={{span: 24}}
                                    xs={{span: 24}}
                                    className="footerMainContainer"
                                >
                                    <div>
                                        <p
                                            className="footerTextMain"
                                        >
                                            READY TO TAKE THE NEXT STEPS?
                                        </p>
                                        <p
                                            className="footerImportantText"
                                        >
                                            <ExclamationCircleOutlined className="footerIcon" />  This App is not for reporting hazards or near misses in the workplace and does not replace field audits

                                        </p>
                                    </div>
                                    
                                    
                                </Col>

                                <Col
                                    xl={{span: 8}}
                                    lg={{span: 8}}
                                    md={{span: 8}}
                                    sm={{span: 24}}
                                    xs={{span: 24}}
                                    className="footerMainContainer"
                                >
                                    <div>
                                        <Row
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'end',
                                            }}
                                        >
                                            <p
                                                className="footerTextSub"
                                            >
                                                Sign in to report your observation
                                            </p>
                                        </Row>

                                        <Row
                                            className="signInButtonContainer"
                                        >
                                            <button
                                                onClick={() => SignIn()}
                                                className="signInButtonAlt"
                                            >SIGN IN</button>
                                        </Row>
                                    </div>
                                    
                                </Col>
                                
                            </Row>
                        </StyledDiv>
                    </Col>
                </Row>
                
            </Content>
        </Layout>
    )
}
